import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useEffect } from 'react';
import { useCreateProspectMutation } from 'services/api/prospects.api';

const InstagramIntegrationSuccess = () => {
  const [createProspect, { isSuccess }] = useCreateProspectMutation();

  useEffect(() => {
    const currentUrl = window.location.href;

    createProspect({
      email: 'instagram_integration@relif.com',
      phone: '',
      rut: '',
      reason: `Instagram integration with Relif: url=${currentUrl}`,
    }).catch((error) => {
      console.error('Error creating prospect', error);
    });
  }, []);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: 'background.default',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
      }}
    >
      <Box
        sx={{
          maxWidth: 480,
          width: '100%',
          textAlign: 'center',
          bgcolor: 'background.paper',
          borderRadius: 3,
          boxShadow: 3,
          p: { xs: 4, md: 6 },
        }}
      >
        <Box sx={{ mb: 4, display: 'flex', justifyContent: 'center' }}>
          <img src="/logo.webp" alt="Relif" style={{ maxWidth: 220, width: '100%', height: 'auto' }} />
        </Box>
        <Typography variant="h4" sx={{ fontWeight: 600 }}>
          Integración de Instagram exitosa
        </Typography>
        {isSuccess && (
          <Typography
            sx={{
              color: 'text.secondary',
              mt: 2,
            }}
          >
            El equipo de Relif ha sido notificado.
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default InstagramIntegrationSuccess;
